import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNav from "../../components/BottomNav"; // Sesuaikan path jika berbeda
import HeaderWithBack from "../../components/HeaderWithBack"; // Sesuaikan path jika berbeda
import axios from '../../api/axios';
import { useAuth } from "../../contexts/AuthContext";
import Loading from "../../components/Loading";

const Profile: React.FC = () => {
    const navigate = useNavigate();
    const handleLogout = () => {
        // logika logout di sini, misal clear token lalu redirect
        navigate("/login"); // Ganti sesuai kebutuhan
    };

    const [profile, setProfile] = React.useState<any>(null);
    const { token: authToken, user: userData } = useAuth();
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`profile`, {
            params: {
              user_id: userData?.id,
            },
            headers: {
              Authorization: `Bearer ${authToken}`,
            }
          });
  
          const data = response.data;
          setProfile(data);
  
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      
      fetchData(); // Selalu fetch saat Home dirender
    }, [authToken]);
    return (
        <div
        style={{
            fontFamily: "Arial, sans-serif",
            // backgroundColor: "#D8F3F7",
            minHeight: "100vh",
            paddingBottom: "60px",
        }}
        >
            {/* Header */}
            <HeaderWithBack title="Profile Saya" />

            {/* Edit Icon */}
            {/* <div className="flex justify-end pr-4 pt-4">
                <button className="bg-teal-500 text-white rounded-full p-2 shadow">
                <i className="fas fa-pencil-alt"></i>
                </button>
            </div> */}
            {/* Profile Card */}
            <div className="w-full p-2 md:w-1/3 p-4">
                {/* Header Card */}
                <div className="mb-4 shadow-sm bg-teal-500 rounded-md">
                    {profile ? (
                        <>
                            <div className="flex flex-col items-center justify-center py-8">
                            <img
                                src="https://m.linksehat.com/assets/img/users/dummy.jpg"
                                alt="User Avatar"
                                className="inline-block object-cover w-40 h-40 mb-10 rounded-full"
                            />
                            <h1 className="text-xl font-semibold text-white">{profile.name ?? ''}</h1>
                            </div>
                        </>
                    ) : (
                        <div className="flex-1 flex items-center justify-center">
                            <Loading color="white"/>
                        </div>
                    )}
                </div>

                {/* Chat History */}
                <div className="mb-4 shadow-sm bg-teal-500 rounded-md text-center p-4">
                    <button
                        onClick={() => navigate("/chat-history", {
                            state: {profileName: profile.name ?? ''}
                        })}
                        className="text-white hover:text-gray-300 inline-block relative"
                    >
                    
                        <i className="fa fa-comments"></i>
                        <span> Chat History</span>
                        <span className="absolute right-0 hidden px-2 py-px mr-2 text-white rounded-full bg-ls total-unread">
                            {/* badge content here if needed */}
                        </span>
                    </button>
                </div>

                {/* E-Prescription */}
                <div className="mb-4 shadow-sm bg-teal-500 rounded-md text-center p-4">
                    <button
                        onClick={() => navigate("/e-prescription")}
                        className="text-white hover:text-gray-300 inline-block relative"
                    >
                    <i className="fa fa-calendar-check"></i>
                    <span> E-Prescription</span>
                    <span className="absolute right-0 hidden px-2 py-px mr-2 text-white rounded-full bg-ls total-unread">
                        {/* badge content here if needed */}
                    </span>
                    </button>
                </div>

                <div className="mb-4 shadow-sm bg-teal-500 rounded-md text-center p-4">
                    <button
                        onClick={() => navigate("/reference")}
                        className="text-white hover:text-gray-300 inline-block relative"
                    >
                    <i className="fa fa-file"></i>
                    <span> Rujukan</span>
                    <span className="absolute right-0 hidden px-2 py-px mr-2 text-white rounded-full bg-ls total-unread">
                        {/* badge content here if needed */}
                    </span>
                    </button>
                </div>

                {/* Health Record */}
                {/* <div className="mb-4 shadow-sm bg-teal-500 rounded-md text-center p-4">
                    <button
                        onClick={() => navigate("/health-record")}
                        className="text-white hover:text-gray-300 inline-block relative"
                    >
                    <i className="fa fa-notes-medical"></i>
                    <span> Health Record</span>
                    <span className="absolute right-0 hidden px-2 py-px mr-2 text-white rounded-full bg-ls total-unread">
                        badge content here if needed
                    </span>
                    </button>
                </div> */}
            </div>

            {/* Contact Information */}
            <div className="mt-4 bg-white mx-4 p-4 rounded-lg border shadow">
                {profile ? (
                    <>
                        <h4 className="text-teal-700 font-semibold text-md mb-4">
                        <i className="fas fa-phone-alt mr-2"></i> Contact Information
                        </h4>
                        <div className="text-sm text-gray-700">
                        <p className="mb-2">
                            <strong>Phone Number:</strong><br />
                            {profile.phone ?? ''}
                        </p>
                        <p>
                            <strong>Email:</strong><br />
                            <a href="mailto:tubaaus@sismedika.com" className="text-blue-600 underline">
                            {profile.email ?? ''}
                            </a>
                        </p>
                        </div>
                    </>
                ) : (
                    <div className="flex-1 flex items-center justify-center">
                        <Loading />
                    </div>
                )}
            </div>

            {/* Personal Detail Card */}
            <div className="mt-4 mx-4 bg-white rounded-lg border shadow p-4">
                {profile ? (
                    <>
                        <h4 className="text-teal-600 font-semibold text-md mb-4">
                        <i className="fas fa-user mr-2"></i>Personal Detail
                        </h4>
                        <div className="grid grid-cols-2 gap-y-3  text-sm text-gray-800">
                        <div>
                            <strong>Age:</strong> <br /> {profile.age ?? ''}
                        </div>
                        <div>
                            <strong>Blood Type:</strong> <br /> {profile.blood_type ?? ''}
                        </div>
                        <div>
                            <strong>Date Of Birth:</strong> <br /> {profile.birth_date ?? ''}
                        </div>
                        <div>
                            <strong>Marriage Status:</strong> <br /> {profile.marital_status ?? ''}
                        </div>
                        <div>
                            <strong>Gender:</strong> <br /> {profile.gender ?? ''}
                        </div>
                        <div>
                            <strong>Weight:</strong> <br /> {profile.weight ?? ''}
                        </div>
                        <div>
                            <strong>NIK:</strong> <br /> {profile.nik ?? ''}
                        </div>
                        <div>
                            <strong>Height:</strong> <br /> {profile.height ?? ''}
                        </div>
                        </div>

                        {/* Address Info */}
                        {profile.address.map((item: any, index: number) => (
                            <div className="mt-4 text-sm text-gray-800" key={index}>
                                <p>
                                    <strong>Alamat:</strong> <br />
                                    {item.text ?? ''}
                                </p>
                                <p className="mt-2">
                                    <strong>Provinsi:</strong> <br /> {item.province ?? ''}
                                </p>
                                <p className="mt-2">
                                    <strong>Kota:</strong> <br /> {item.city ?? ''}
                                </p>
                                <p className="mt-2">
                                    <strong>Kecamatan:</strong> <br /> {item.district ?? ''}
                                </p>
                                <p className="mt-2">
                                    <strong>Kelurahan:</strong> <br /> {item.village ?? ''}
                                </p>
                                <p className="mt-2">
                                    <strong>Kode Pos:</strong> <br /> {item.postal_code ?? ''}
                                </p>
                            </div>
                        ))}
                    </>
                ) : (
                    <div className="flex-1 flex items-center justify-center">
                        <Loading />
                    </div>
                )}
            </div>
              

        {/* Logout Button */}
        <div className="mt-6 mx-4 mb-4">
            {/* <button
            onClick={handleLogout}
            className="w-full bg-red-600 text-white font-semibold py-3 rounded-full shadow"
            >
            <i className="fas fa-sign-out-alt mr-2"></i> LOGOUT
            </button> */}
        </div>

            {/* Bottom Navigation */}
            <BottomNav />
        </div>
    );
};

export default Profile;
